import { useSelector } from "react-redux";
import { selectLoading } from "state/slices/loaderSlice";
import "styles/css/loader.css";

const Loader = () => {
  const isLoading = useSelector(selectLoading);
  if (!isLoading) return null;

  return (
    <>
      {isLoading && (
        <div className="loader-overlay">
          <span className="loader"></span>
        </div>
      )}
    </>
  );
};

export default Loader;
